import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL + '/modules'; // URL de devices


// Get all devices (considering pagination, filtering and sorting)
export async function getAllModules(token) {
  try {
    const response = await axios.get(API_BASE_URL+'/all',
      {
        headers: {Authorization: "Bearer "+token}
      }
    );
    return response.data;
  } catch (error) {
    throw  error;
  }
}

